import { render } from "./search-icon.vue?vue&type=template&id=9ba7fd44"
import script from "./search-icon.vue?vue&type=script&lang=js"
export * from "./search-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__